// Brief 4 Tela 12 — Insights Estratégicos do Gestor (lens=gestor). Re-usa a tela da Tela 10 do
// Supervisor parametrizada pela lente (follow-up D13). Rota: /estrategia/insights-gestor.
import { InsightsPage } from '../features/supervisor/telas/insights/InsightsPage';

import type React from 'react';

export function InsightsGestorPage(): React.JSX.Element {
  return <InsightsPage lens="gestor" />;
}
